export const LEAD_SOURCES = [
  'Zillow',
  'LendingTree',
  'Referral Partner',
  'Realtor',
  'Repeat Client',
  'Direct Mail',
  'Call Center',
  'Bankrate',
  'Social Media',
  'Builder Partner',
  'CPA Referral',
  'Organic Web',
].sort((a, b) => a.localeCompare(b))

export type CommissionModel = 'BPS' | 'CDS'

export interface User {
  id: string
  name: string
  title: string
  avatar: string
  model: CommissionModel
  rates?: Record<string, number> // For BPS users
  fundedMTD: number
  fundedLastMonth: number
  // Mocking the breakdown of funded loans by source for BPS calculation
  fundedBySource?: Record<string, { count: number; volume: number }>
}

const firstNames = [
  'James',
  'Mary',
  'John',
  'Patricia',
  'Robert',
  'Jennifer',
  'Michael',
  'Linda',
  'William',
  'Elizabeth',
  'David',
  'Barbara',
  'Richard',
  'Susan',
  'Joseph',
  'Jessica',
  'Thomas',
  'Sarah',
  'Charles',
  'Karen',
  'Christopher',
  'Lisa',
  'Daniel',
  'Nancy',
  'Matthew',
  'Betty',
  'Anthony',
  'Margaret',
  'Mark',
  'Sandra',
  'Donald',
  'Ashley',
  'Steven',
  'Kimberly',
  'Paul',
  'Emily',
  'Andrew',
  'Donna',
  'Joshua',
  'Michelle',
  'Kenneth',
  'Carol',
  'Kevin',
  'Amanda',
  'Brian',
  'Melissa',
  'George',
  'Deborah',
  'Timothy',
  'Stephanie',
  'Ronald',
  'Rebecca',
  'Edward',
  'Sharon',
  'Jason',
]
const lastNames = [
  'Smith',
  'Johnson',
  'Williams',
  'Brown',
  'Jones',
  'Garcia',
  'Miller',
  'Davis',
  'Rodriguez',
  'Martinez',
  'Hernandez',
  'Lopez',
  'Gonzalez',
  'Wilson',
  'Anderson',
  'Thomas',
  'Taylor',
  'Moore',
  'Jackson',
  'Martin',
  'Lee',
  'Perez',
  'Thompson',
  'White',
  'Harris',
  'Sanchez',
  'Clark',
  'Ramirez',
  'Lewis',
  'Robinson',
  'Walker',
  'Young',
  'Allen',
  'King',
  'Wright',
  'Scott',
  'Torres',
  'Nguyen',
  'Hill',
  'Flores',
  'Green',
  'Adams',
  'Nelson',
  'Baker',
  'Hall',
  'Rivera',
  'Campbell',
  'Mitchell',
  'Carter',
  'Roberts',
  'Gomez',
  'Phillips',
  'Evans',
  'Turner',
  'Diaz',
]

function getRandomInt(min: number, max: number) {
  return Math.floor(Math.random() * (max - min + 1)) + min
}

export const MOCK_USERS: User[] = Array.from({ length: 55 }).map((_, i) => {
  const isCDS = Math.random() > 0.8 // ~20% CDS users
  const model: CommissionModel = isCDS ? 'CDS' : 'BPS'

  const rates: Record<string, number> = {}
  const fundedBySource: Record<string, { count: number; volume: number }> = {}

  let totalFundedMTD = 0

  if (model === 'BPS') {
    LEAD_SOURCES.forEach((source) => {
      rates[source] = getRandomInt(45, 115)

      // Assign some random funded loans to a few sources
      if (Math.random() > 0.6) {
        const count = getRandomInt(1, 5)
        const volume = count * getRandomInt(250000, 450000)
        fundedBySource[source] = { count, volume }
        totalFundedMTD += count
      }
    })
  } else {
    totalFundedMTD = getRandomInt(2, 15)
  }

  const name = `${firstNames[i % firstNames.length]} ${lastNames[i % lastNames.length]}`

  return {
    id: `user-${i + 1}`,
    name,
    title: isCDS
      ? 'CDS Specialist'
      : Math.random() > 0.5
        ? 'Senior Loan Officer'
        : 'Loan Officer',
    avatar: `https://ui-avatars.com/api/?name=${encodeURIComponent(name)}&background=random`,
    model,
    ...(model === 'BPS' ? { rates, fundedBySource } : {}),
    fundedMTD: totalFundedMTD,
    fundedLastMonth: Math.max(0, totalFundedMTD + getRandomInt(-3, 4)),
  }
})

export const INITIAL_CDS_TIERS = [
  { id: '1', min: 1, max: 3, amount: 300 },
  { id: '2', min: 4, max: 7, amount: 500 },
  { id: '3', min: 8, max: 11, amount: 600 },
  { id: '4', min: 12, max: null, amount: 750 },
]
